module.exports = __webpack_public_path__ + "static/media/icon-Settings.59a3454e.svg";